/* qeslint-disable */

import { DataStore } from "./util_datastore";

export class DataProx {
    path: string;
    store: DataStore;

    constructor(store: DataStore, path: string) {
        this.path = path;
        this.store = store;
    }

    get value(): any {
        return this.store.getValue(this.path);
    }

    set value(val: any) {
        this.store.setValue(this.path, val);
    }

    get(path: string): DataProx {
        return this.store.get(path, this.path);
    }
}
